import { useTranslation } from 'react-i18next';
import type { AppointmentPaymentStatus } from '@shared/constants/index.ts';
import { classes } from '../ui.tsx';

const TONES: Record<AppointmentPaymentStatus, string> = {
  not_billed: 'border-[color:var(--color-line)] text-[color:var(--color-muted)]',
  pending: 'border-[color:var(--color-warning)] text-[color:var(--color-warning)]',
  paid: 'border-[color:var(--color-brand)] bg-[color:var(--color-brand-soft)] text-[color:var(--color-brand-strong)]',
  failed: 'border-[color:var(--color-danger)] text-[color:var(--color-danger)]',
  refunded: 'border-[color:var(--color-line)] text-[color:var(--color-muted)]',
  partially_refunded: 'border-[color:var(--color-warning)] text-[color:var(--color-warning)]',
};

export function PaymentBadge({ status }: { status: AppointmentPaymentStatus }) {
  const { t } = useTranslation();
  return <span className={classes('badge', TONES[status])}>{t(`payments.appointmentStatus.${status}`)}</span>;
}
